<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1>Woman Development Cell</h1>
                </div>
            </div>
        </div>			
    </div>
</section>      

<section class="section-lg std-scholarship">
    <div class="container">
        <div class="table-responsive" >
            <table class="table table-bordered text-center tbl_custom">
				<thead>
					<tr>
						
						<th>Sr.No.</th>
						<th>Name</th>
						<th>Designation</th>
						
					</tr>
				</thead>
				<tbody>
					
					<tr>
						<td>1</td>
						<td>Dr. Jasvinder Kaur</td>
						<td>Chairperson</td>
						
					</tr>
					<tr>
						<td>2</td>
						<td>Dr Jyoti Pillay</td>
						<td>Senior Faculty Member</td>
						
					</tr>
					<tr>
						<td>3</td>
						<td>Ms. Arumita Pawa</td>
						<td>Senior Faculty Member</td>
						
					</tr>
					<tr>
						<td>4</td>
						<td>Ms Nikita Tiwari</td>
						<td>Faculty Member</td>
						
					</tr>
					<tr>
						<td>5</td>
						<td>Ms Sakshi Madderlawar</td>
						<td>Student Representative</td>
						
					</tr>
					<tr>
						<td>6</td>
						<td>Ms Shruti Gupta</td>
						<td>Student Representative</td>
						
					</tr>
					
				</tbody>
			</table>
        </div>
    </div>
</section>
